import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';

import get from 'lodash.get';
import qs from 'query-string';

import { EmployeeNode } from '../types';

import {
  RELATIONSHIP,
  FOLLOW_EMPLOYEE_ACTION,
  FOLLOW_EMPLOYEE_ID_PARAM,
} from '../utils';

export type UseNetworkRequestLoggedOutActionProps = {
  authenticated: boolean;
  executeNetworkRequest: (id: string) => void;
  employees: EmployeeNode[];
  loading: boolean;
};

const useNetworkRequestLoggedOutAction = ({
  authenticated,
  executeNetworkRequest,
  employees,
  loading,
}: UseNetworkRequestLoggedOutActionProps) => {
  const location = useLocation();
  let history = useHistory(); // eslint-disable-line
  const hasAction =
    get(qs.parse(decodeURIComponent(location.search)), 'action') ===
    FOLLOW_EMPLOYEE_ACTION;

  const followEmployeeId = get(
    qs.parse(decodeURIComponent(location.search)),
    FOLLOW_EMPLOYEE_ID_PARAM
  );

  useEffect(() => {
    if (loading || !employees?.length || !authenticated || !hasAction) return;

    if (followEmployeeId && employees) {
      const employeeInList = employees.find(
        ({
          node: {
            profileDetails: { id },
          },
        }) => id === followEmployeeId
      );

      const isAlreadyContact =
        employeeInList &&
        employeeInList.node.networkRelationship.relationship !==
          RELATIONSHIP.NONE;

      if ((employeeInList && !isAlreadyContact) || !employeeInList) {
        executeNetworkRequest(followEmployeeId);
      }
    }

    history.push({
      search: '',
    });
  }, [followEmployeeId, hasAction, employees]);

  return null;
};

useNetworkRequestLoggedOutAction.propTypes = {
  toggle: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  currentValue: PropTypes.bool,
};

export { useNetworkRequestLoggedOutAction };
